exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label.custom-control.custom-checkbox{display: block !important;}\n.custom-control-description{color:#646464;}\n.custom-control-input:checked~.custom-control-indicator{background-color: #67a0a5;}\n.custom-file-control{padding:2px 10px;}\n.custom-file-control::before{line-height: 1;}\n.custom-file-control:lang(en)::before{content: \"Upload\";}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/academic-information/academic-information.component.css
// module id = ../../../../../src/app/pages/profile/academic-information/academic-information.component.css
// module chunks = main